/**
 * @module FE-CU41_承認否認選択画面
 */
import Header from '../../components/header/Header.vue';
import ListPanel from '../../components/listPanel/ListPanel.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '@/components/breadCrumb/List.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU41';

export default {
  name: 'AddressDetail',
  components: {
    Header,
    ListPanel,
    PcPageTitle,
    BreadCrumbList,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU41承認可否選択画面.承認可否選択'),
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU41承認可否選択画面.C0001'),
      panelResult: [],
      displayResult: {
        customerNumber: '',
        securityDestinationName: '',
        districtSplitNumber: '',
        districtSplitName: '',
        displayDistrictNickname: '',
        cameraNickName: '',
        deviceID: '',
      },
      mainUserResult: { userId: '', name: '' },
      subUserResult: { userId: '', name: '' },
      usagePlan: null,
      denial: false,
      denialConfirm: false,
      oneTimeUrlId: '',
      type: 'APP_CU4101',
      beforeMail: '',
      afterMail: '',
      CONSTANTS: CONSTANTS,
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU41承認可否選択画面.承認可否選択'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU41承認可否選択画面.C0001'),
      };
    },
    withSubUser() {
      if (this.type === 'APP_CU4103' || this.type === 'APP_CU4104') {
        return true;
      } else {
        return false;
      }
    },
  },
  /** @type {Methods} */
  methods: {
    active: function () {
      this.isActive = !this.isActive;
    },
    /**
     * 初期表示API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    init: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ(メインユーザー移譲(対象地区)) /initMainUserTransferDisplayDistrict
            // apiData = {
            //   contentsInfo: {
            //     oneTimeUrlStatus: 0, // 0：正常, １：存在しないURL
            //     // 対象地区情報
            //     // displayDistrictInfo: {
            //     //   usagePlan: 1, // 0: オンライン監視プラン 1: 依頼かけつけプラン 2:セルフ監視プラン
            //     //   customerNumber: "51-1234567", // お客様番号
            //     //   securityDestinationName: "警備先1", // 警備先名
            //     //   districtSplitNumber: "0001", // 地区番号
            //     //   districtSplitName: "地区名1234", // 地区名
            //     //   displayDistrictNickname: "ニックネーム1", // ニックネーム(対象地区)
            //     // },
            //     displayDistrictInfo: {
            //       usagePlan: 1, // 0: オンライン監視プラン 1: 依頼かけつけプラン 2:セルフ監視プラン
            //       customerNumber: "51-1234567811111111111111111111111111111111111111111111111111111111111111111111111111", // お客様番号
            //       securityDestinationName: "警備先11111111111111111111111111111111111111111111111111111111111111111111111111111111", // 警備先名
            //       districtSplitNumber: "00011111111111111111111111111111111111111111111111111111111111111111111111111111111111111", // 地区番号
            //       districtSplitName: "地区名12341111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", // 地区名
            //       displayDistrictNickname: "ニックネーム11111111111111111111111111111111111111111111111111111111111111111111111111111111", // ニックネーム(対象地区)
            //     },
            //     // メインユーザー情報
            //     mainUserInfo: {
            //       userId: "123456789@abc.com",
            //       name: "警備 太郎",
            //     },
            //     // サブユーザー情報
            //     subUserInfo: {
            //       userId: "123456788@abc.com",
            //       name: "警備 次郎",
            //     },
            //   },
            // };
            // サンプルデータ(メインユーザー移譲(カメラ)) /initMainUserTransferCamera
            // apiData = {
            //   contentsInfo: {
            //     oneTimeUrlStatus: 0, // 0：正常, １：存在しないURL
            //     // カメラ情報
            //     cameraInfo: {
            //       usagePlan: 101, // 100: オンライン監視プラン 101: 依頼かけつけプラン 102:セルフ監視プラン
            //       customerNumber: "51-1234567", // お客様番号
            //       securityDestinationName: "警備先1", // 警備先名
            //       districtSplitNumber: "0001", // 地区番号
            //       districtSplitName: "地区名1234", // 地区名
            //       displayDistrictNickname: "自宅", // ニックネーム(対象地区)
            //       cameraNickName: "リビングカメラ", // ニックネーム(カメラ)
            //       deviceID: "1234",
            //     },
            //     // メインユーザー情報
            //     mainUserInfo: {
            //       userId: "123456789@abc.com",
            //       name: "警備 太郎",
            //     },
            //     // サブユーザー情報
            //     subUserInfo: {
            //       userId: "123456788@abc.com",
            //       name: "警備 次郎",
            //     },
            //   },
            // };
            // サンプルデータ(メインユーザー移譲(対象地区)) /initRegistrationSubUserDisplayDistrict
            // apiData = {
            //   contentsInfo: {
            //     oneTimeUrlStatus: 0, // 0：正常, １：存在しないURL
            //     // 対象地区情報
            //     // displayDistrictInfo: {
            //     //   usagePlan: 1, // 0: オンライン監視プラン 1: 依頼かけつけプラン 2:セルフ監視プラン
            //     //   customerNumber: "51-12345678", // お客様番号
            //     //   securityDestinationName: "警備先1", // 警備先名
            //     //   districtSplitNumber: "0001", // 地区番号
            //     //   districtSplitName: "地区名1234", // 地区名
            //     //   displayDistrictNickname: "ニックネーム1", // ニックネーム(対象地区)
            //     // },
            //     displayDistrictInfo: {
            //       usagePlan: 1, // 0: オンライン監視プラン 1: 依頼かけつけプラン 2:セルフ監視プラン
            //       customerNumber: "51-12345678111111111111111111111111111111111111111", // お客様番号
            //       securityDestinationName: "警備先111111111111111111111111111111111111111111111", // 警備先名
            //       districtSplitNumber: "000111111111111111111111111111111111111111111111111111", // 地区番号
            //       districtSplitName: "地区名123411111111111111111111111111111111111111111111111111111", // 地区名
            //       displayDistrictNickname: "ニックネーム111111111111111111111111111111111111111111111", // ニックネーム(対象地区)
            //     },
            //   },
            // };
            // サンプルデータ(メインユーザー移譲(カメラ)) /initRegistrationSubUserCamera
            // apiData = {
            //   contentsInfo: {
            //     oneTimeUrlStatus: 0, // 0：正常, １：存在しないURL
            //     // カメラ情報
            //     cameraInfo: {
            //       usagePlan: 100, // 100: オンライン監視プラン 101: 依頼かけつけプラン 102:セルフ監視プラン
            //       customerNumber: "aaaa", // お客様番号
            //       securityDestinationName: "警備先1", // 警備先名
            //       districtSplitNumber: "0001", // 地区番号
            //       districtSplitName: "地区名1234", // 地区名
            //       displayDistrictNickname: "ニックネーム1", // ニックネーム(対象地区)
            //       cameraNickName: "カメラニックネーム1", // ニックネーム(カメラ)
            //       deviceID: "1234",
            //     },
            //   },
            // };
            // apiData = {
            //   contentsInfo: {
            //     oneTimeUrlStatus: 0,
            //     beforeMail: "before@example.com",
            //     afterMail: "after@example.com",
            //   },
            // };

            if (apiData.contentsInfo.oneTimeUrlStatus == 1) {
              // number: 0：正常, １：存在しないURL
              this.$store.commit('setThanksType', { displayType: 5 });
              this.$router.replace({ name: 'Thanks' });
              return;
            }

            if (this.type === 'APP_CU4109') {
              this.beforeMail = apiData.contentsInfo.beforeMail;
              this.afterMail = apiData.contentsInfo.afterMail;
            } else {
              // ------- データ整形 ---------

              // ユーザー表示用にデータを設定
              this.mainUserResult = apiData?.contentsInfo?.mainUserInfo
                ? apiData.contentsInfo.mainUserInfo
                : null;
              this.subUserResult = apiData?.contentsInfo?.subUserInfo
                ? apiData.contentsInfo.subUserInfo
                : null;

              if (this.type === 'APP_CU4101' || this.type === 'APP_CU4103') {
                const planTitles = {
                  [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                    '$vuetify.コード.利用プランID.オンライン監視プラン',
                  [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                    '$vuetify.コード.利用プランID.依頼かけつけプラン',
                  [CONSTANTS.HOME_SECURITY_USAGE_PLAN
                    .EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
                    '$vuetify.コード.利用プランID.依頼かけつけプラン',
                  [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
                    '$vuetify.コード.利用プランID.セルフ監視プラン',
                  [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
                    '$vuetify.コード.利用プランID.セルフ監視プラン',
                };

                this.displayResult = apiData.contentsInfo.displayDistrictInfo;
                this.usagePlan = planTitles[apiData.contentsInfo.displayDistrictInfo.usagePlan];

                if (this.type === 'APP_CU4101') {
                  delete this.displayResult.districtSplitNumber;
                  delete this.displayResult.districtSplitName;
                  delete this.displayResult.displayDistrictNickname;
                } else if (
                  apiData.contentsInfo.displayDistrictInfo.districtSplitNumber === '    '
                ) {
                  this.displayResult.districtSplitNumber =
                    '$vuetify.FECU41承認可否選択画面.メイン地区';
                  this.displayResult.securityDestinationName =
                    apiData.contentsInfo.displayDistrictInfo.securityDestinationName;
                } else if (apiData.contentsInfo.displayDistrictInfo.districtSplitNumber === '') {
                  delete this.displayResult.districtSplitNumber;
                }
              } else if (this.type === 'APP_CU4102' || this.type === 'APP_CU4104') {
                const planTitles = {
                  [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                    '$vuetify.コード.利用プランID.オンライン監視プラン',
                  [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                    '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
                  [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
                    '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
                };

                this.displayResult = apiData.contentsInfo.cameraInfo;
                this.usagePlan = planTitles[apiData.contentsInfo.cameraInfo.usagePlan];
                this.displayResult.districtSplitName =
                  apiData.contentsInfo.cameraInfo.districtSplitName;
                this.displayResult.device = apiData.contentsInfo.cameraInfo.deviceID;
                this.displayResult.securityDestinationName =
                  apiData.contentsInfo.cameraInfo.securityDestinationName;
                if (apiData.contentsInfo.cameraInfo.districtSplitNumber === '    ') {
                  this.displayResult.districtSplitNumber =
                    '$vuetify.FECU41承認可否選択画面.メイン地区';
                } else if (apiData.contentsInfo.cameraInfo.districtSplitNumber === '') {
                  delete this.displayResult.districtSplitNumber;
                }
              }
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    replace(url) {
      this.$router.replace({
        path: url,
        //query: { hoge_token: data }
      });
    },
    /**
     * 更新API実行処理(承認・否認)
     * @param {*} classification 承認区分
     * @param {*} resultMessage 完了メッセージ
     * @returns apiData レスポンス
     */
    postApi: async function (classification, resultMessage) {
      let param = '';
      if (this.type === 'APP_CU4101') {
        param = '/api/approvalSelect/mainUserTransferDisplayDistrictApproval';
      } else if (this.type === 'APP_CU4102') {
        param = '/api/approvalSelect/mainUserTransferCameraApproval';
      } else if (this.type === 'APP_CU4103') {
        param = '/api/approvalSelect/registrationSubUserDisplayDistrictApproval';
      } else if (this.type === 'APP_CU4104') {
        param = '/api/approvalSelect/registrationSubUserCameraApproval';
      } else if (this.type === 'APP_CU4109') {
        param = '/api/approvalSelect/changeUserInfoApproval';
      }

      // let param = "post"; // メインユーザー移譲_承認確認（対象地区）

      let queries = {
        oneTimeUrlId: this.oneTimeUrlId, // ワンタイムURLID
        approvalKbn: classification, // 承認区分
      };
      let method = 'post';

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // number: 0：正常, １：存在しないURL
            // APP_CU4110はレスポンスなしのため以下の条件から除外
            if (this.type !== 'APP_CU4109' && apiData.contentsInfo.oneTimeUrlStatus == 1) {
              this.$store.commit('setThanksType', { displayType: 5 });
              this.$router.replace({ name: 'Thanks' });
              return;
            }
            this.callMessageDialog(resultMessage);
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     number: 0,
            //   },
            // };
            // a)承認区分 == 0:承認 の場合
            // メインユーザー変更承認完了ダイアログを表示する。
            // サブユーザー登録承認完了ダイアログを表示する。
            // ユーザー情報変更承認完了ダイアログを表示する。
            // b)承認区分 == 1:否認 の場合
            // メインユーザー変更否認完了ダイアログを表示する。
            // サブユーザー変更否認完了ダイアログを表示する。
            // ユーザー情報変更承認完了ダイアログを表示する。
          },
          (error) => {
            if (error.message.includes('400')) {
              let errorMessageId = '';
              if (this.type === 'APP_CU4101' || this.type === 'APP_CU4102') {
                // メインユーザー移譲
                errorMessageId = 'E0001';
              } else if (this.type === 'APP_CU4103' || this.type === 'APP_CU4104') {
                // サブユーザー登録
                errorMessageId = 'E0002';
              } else {
                // ユーザ情報変更
                errorMessageId = 'E0003';
              }
              this.$errorDialog(`$vuetify.メッセージ一覧.FECU41承認可否選択画面.${errorMessageId}`);
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        );
      // APP_CU4106
      // APP_CU4107
      // APP_CU4108
      // APP_CU4110
      return apiData;
    },
    /**
     * 承認・否認ボタン押下時処理
     * 確認ダイアログを表示して更新APIを実行
     * @param {boolean} approvalFlag 承認フラグ
     */
    async callSaveAgreementDialogDialog(approvalFlag) {
      const classification = approvalFlag ? 0 : 1;

      let confirmMessageId = '';
      let informationMessageId = '';

      switch (this.type) {
        case 'APP_CU4101':
        case 'APP_CU4102':
          if (approvalFlag) {
            confirmMessageId = 'C0002';
            informationMessageId = 'C0004';
          } else {
            confirmMessageId = 'C0003';
            informationMessageId = 'C0005';
          }
          break;
        case 'APP_CU4103':
        case 'APP_CU4104':
          if (approvalFlag) {
            confirmMessageId = 'C0006';
            informationMessageId = 'C0008';
          } else {
            confirmMessageId = 'C0007';
            informationMessageId = 'C0009';
          }
          break;
        default:
          if (approvalFlag) {
            confirmMessageId = 'C0010';
            informationMessageId = 'C0012';
          } else {
            confirmMessageId = 'C0011';
            informationMessageId = 'C0013';
          }
          break;
      }

      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        `$vuetify.メッセージ一覧.FECU41承認可否選択画面.${confirmMessageId}`,
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );

      if (result) {
        // はいを押すと更新処理実行
        await this.postApi(
          classification,
          `$vuetify.メッセージ一覧.FECU41承認可否選択画面.${informationMessageId}`
        );
      }
    },
    /**
     * 完了ダイアログを表示してログイン画面へ遷移
     * @param {*} text 完了メッセージ
     */
    async callMessageDialog(text) {
      await this.$informationDialog(text);

      // ログイン画面に遷移
      this.$router.replace({ path: '/login' });
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    // 画面サイズ変更
    this.$watch('$mq', function () {
      this.width = 180;
    });

    // 言語切り替え
    this.$watch(this.$vuetify.lang.current, function () {
      this.width = this.$refs.itemLabel.getBoundingClientRect().width;
    });

    if (this.$mq === 'sp') {
      this.width = 180;
    }

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    const branch = this.$route.params.branch;
    const oneTimeUrlID = this.$route.params.oneTimeUrlID;
    this.oneTimeUrlId = this.$route.params.oneTimeUrlID;

    let param = '';
    if (branch === 'mainUserTransferDistrict') {
      // APP_CU4101 初期表示(メインユーザー移譲(対象地区))
      param = '/api/approvalSelect/initMainUserTransferDisplayDistrict';
      this.type = 'APP_CU4101';
    } else if (branch === 'mainUserTransferCamera') {
      // APP_CU4102 初期表示（メインユーザー移譲（カメラ）)
      param = '/api/approvalSelect/initMainUserTransferCamera';
      this.type = 'APP_CU4102';
    } else if (branch === 'subUserTransferDistrict') {
      // APP_CU4103 初期表示（新規サブユーザー登録（対象地区）)
      param = '/api/approvalSelect/initRegistrationSubUserDisplayDistrict';
      this.type = 'APP_CU4103';
    } else if (branch === 'subUserTransferCamera') {
      // APP_CU4104 初期表示（新規サブユーザー登録（カメラ）)
      param = '/api/approvalSelect/initRegistrationSubUserCamera';
      this.type = 'APP_CU4104';
    } else if (branch === 'changeUserInfo') {
      // APP_CU409 初期表示（ユーザ情報変更）
      param = '/api/approvalSelect/initChangeUserInfo';
      this.type = 'APP_CU4109';
    } else {
      this.$store.commit('setSorryType', { sorryType: 4 });
      this.$router.replace({ name: 'Sorry' });
    }

    if (!branch || !oneTimeUrlID) {
      this.$store.commit('setSorryType', { sorryType: 4 });
      this.$router.replace({ name: 'Sorry' });
    }

    let queries = {
      oneTimeUrlId: oneTimeUrlID,
    };

    //ローディングマーク表示と合わせて色々再見直ししたほうが良いかも
    this.isShowPage = true;

    let method = 'post';
    await this.init(param, queries, method);
  },
};
